import { inject, Injectable } from '@angular/core';
import { FireAuthService } from '../../services/fire-auth.service';
import { BossAuthService } from '../../services/boss-auth.service';
import { BossAuthTokenService } from '../../services/boss-auth-token.service';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  // private fireAuthService = inject(FireAuthService);
  // private bossAuthService = inject(BossAuthService);
  // private bossAuthTokenService = inject(BossAuthTokenService);

  constructor() {}

  /**
   * A utility function to handle requests that may require refreshing tokens.
   *
   * This function takes a request function and attempts to execute it. If the
   * request fails with a token-related error, it will attempt to refresh the
   * tokens and retry the request. If the retry fails, it will throw the error.
   *
   * @param requestFn A function that returns a promise of the request result.
   * @returns A promise of the request result, or the error if the retry failed.
   */
  async handleRequest(requestFn: () => Promise<any>) {
    const response = await requestFn();
    return response;
    // try {
    // } catch (error) {
    //   console.log('Request error', error);
    //   return await this.handleRequestErrors(error);
    //   // try {
    //   //   return await requestFn();
    //   // } catch (retryError) {
    //   //   console.log('Retry failed', retryError);
    //   //   return retryError;
    //   // }
    // }
  }
}
